import React, {useEffect, useState} from 'react';
// @ts-ignore
import Modal from "react-modal";
import { useTranslations } from 'next-intl'

export const MultipleSelectModal = ({ options, name, onSelectionApply, placeholder, preSelectedItems = [] }: any) => {
    const t = useTranslations('')
    const [selectedItems, setSelectedItems]: any = useState([])
    const [selectedFullItems, setSelectedFullItems]: any = useState([])
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showModal]);

    const handleSelectItem = (item: any) => {
        // @ts-ignore
        if (selectedItems.includes(item.value)) {
            const result = [...selectedItems];
            const fullResult = [...selectedFullItems];
            // @ts-ignore
            const index = result.indexOf(item.value);
            if (index !== -1) {
                result.splice(index, 1);
                fullResult.splice(index, 1);
            }
            setSelectedItems(result);
            setSelectedFullItems(fullResult);
        } else {
            // @ts-ignore
            setSelectedFullItems([...selectedFullItems, item])
            // @ts-ignore
            setSelectedItems([...selectedItems, item.value])
        }
    }

    const handleApply = () => {
        if (onSelectionApply) {
            onSelectionApply(name, selectedFullItems);
        }
        setShowModal(false);
    }
    const handleReject = () => {
        setSelectedFullItems([]);
        setSelectedItems([]);
        setShowModal(false);
    }
    return (
        <div className="regions-select-container">
            <div className="regions-select-box" onClick={() => setShowModal(true)}>
                <div className="regions-chips">
                    {selectedFullItems.length > 0 ? (
                        selectedFullItems.map((item: any) => (
                            <div key={item.value} className="regions-chip">
                                {item.label}
                            </div>
                        ))
                    ) : (
                        <div className="regions-placeholder">
                            {placeholder}
                        </div>
                    )}
                </div>
            </div>

            <input type="hidden" name={name} value={selectedItems}/>

            <Modal
                isOpen={showModal}
                className="select-regions-mobile-modal"
                overlayClassName="estateViewOverlay"
                contentLabel="Select Regions"
            >
                <div className="select-regions-mobile-modal-content">
                    <div className="regions-select-items">
                        {options.map((item: any) => (
                            <p
                                className={selectedItems.includes(item.value) ? 'selected' : ''}
                                key={item.value}
                                onClick={() => handleSelectItem(item)}
                            >
                                {item.label}
                            </p>
                        ))}
                    </div>
                </div>
                <div className="select-regions-mobile-modal-bottom">
                    <button className="select2-mobile-button-submit" onClick={handleApply}>{t('Region Select')}</button>
                    <button className="select2-mobile-button-cancel" onClick={handleReject}>{t('Region Reject')}</button>
                </div>

            </Modal>
        </div>
    );
};
